import MenuButton from "./MenuButton";
import "./Menu.css";
import { ReactComponent as CircleArrowRight } from "./static/icons/CircleArrowRight.svg";
import { ReactComponent as Dismiss } from "./static/icons/Dismiss.svg";
import { goToPage } from "./Slide";

function Menu({ closeMenu, isMenuOpen }) {
  return (
    <div className={isMenuOpen ? "Overlay" : "Overlay-Hidden"}>
      <div className={isMenuOpen ? "menu-content" : "menu-content-hidden"}>
        <div className="DismissContainer">
          <MenuButton
            variant={"icon"}
            icon={<Dismiss />}
            onClick={closeMenu}
          ></MenuButton>
        </div>

        <div className="menu-item">
          <MenuButton
            text="CASE 1 - BIM QUALITY ASSURANCE"
            icon={<CircleArrowRight />}
            onClick={() => goToPage("/case1")}
            style={{
              transitionDelay: isMenuOpen ? "0.8s" : "0s",
            }}
          ></MenuButton>
        </div>
        <div className="menu-item">
          <MenuButton
            text="CASE 2 - USER FEEDBACK ANALYSIS"
            icon={<CircleArrowRight />}
            onClick={() => goToPage("/case2")}
            style={{
              transitionDelay: isMenuOpen ? "0.9s" : "0s",
            }}
          ></MenuButton>
        </div>
        <div className="menu-item">
          <MenuButton
            text="CASE 3 - PROPER ONBOARDING"
            icon={<CircleArrowRight />}
            onClick={() => goToPage("/case3")}
            style={{ transitionDelay: isMenuOpen ? "1s" : "0s" }}
          ></MenuButton>
        </div>
        <div className="menu-item">
          <MenuButton
            text="CASE 4 - BUILDING CREDIT"
            icon={<CircleArrowRight />}
            onClick={() => goToPage("/case4")}
            style={{
              transitionDelay: isMenuOpen ? "1.1s" : "0s",
            }}
          ></MenuButton>
        </div>
      </div>
    </div>
  );
}

export default Menu;
